module.exports = __webpack_public_path__ + "static/img/12.4358cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/12.jpg
// module id = qC9L
// module chunks = 1